import type { ReactNode } from 'react';

import { createPortal } from 'react-dom';

import { useForumContext } from '../ForumLayout.context';

type Props = {
  children: ReactNode;
};

export const ForumHeaderPortal = ({ children }: Props) => {
  const { headerPortal } = useForumContext();

  if (headerPortal === null) return null;

  return createPortal(children, headerPortal);
};
